import { Notyf } from 'notyf';

const notyf = new Notyf({
  duration: 3000,
  position: {
    x: 'right',
    y: 'top',
  },
  types: [
    {
      type: 'primary',
      background: '#007bff',
      dismissible: true,
      duration: 3000,
    },
    {
      type: 'info',
      background: '#17a2b8',
      dismissible: true,
      duration: 5000,
      icon: {
        className: 'bi bi-info-circle',
        // className: 'fa-fw fa-lg fas fa-info-circle',
        tagName: 'i',
        color: 'inherit',
      },
    },
    {
      type: 'warning',
      background: '#ffc107',
      dismissible: true,
      icon: {
        className: 'bi bi-exclamation-triangle',
        // className: 'fa-fw fa-lg fas fa-exclamation-triangle',
        tagName: 'i',
        color: 'inherit',
      },
    },
    {
      type: 'error',
      background: '#dc3545',
      dismissible: true,
      icon: {
        className: 'bi bi-exclamation-circle',
        // className: 'fa-fw fa-lg fas fa-exclamation-circle',
        tagName: 'i',
        color: 'inherit',
      },
    },
  ],
});

global.notyf = notyf;

document.addEventListener('DOMContentLoaded', () => {
  if (!global.Livewire) {
    return;
  }

  global.Livewire.on('notyf', function (data) {
    if ('string' === typeof data) {
      notyf.open({
        type: 'info',
        message: data,
      });
    } else {
      notyf.open(data);
    }
  });
});

export default notyf;
